// extracted by mini-css-extract-plugin
module.exports = {"button":"invalidDomainDialog_button__28Ijb","progress-bar-custom":"invalidDomainDialog_progress-bar-custom__27X_g"};